module.exports = __webpack_public_path__ + "static/green-31241cc810b8114ee0d7473aac373e22.png";